import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Most traders trade emotion",
    body: "Fear buys the top and greed holds too long. Without a written plan, every decision becomes a reaction — and reactions are expensive.",
  },
  {
    n: "02",
    title: "Preparation is the advantage",
    body: "Bias, key events and positioning aren't secrets — they're work. Inside the club, that work is done for you and delivered daily, before the market moves.",
  },
  {
    n: "03",
    title: "One market. Full focus.",
    body: "Spreading across every chart dilutes attention. Members study one market — gold — with real depth.",
  },
  {
    n: "04",
    title: "Routine compounds",
    body: "Daily sessions, weekend reviews and a desk that answers. Progress comes from showing up consistently — the room is built around that habit.",
  },
];

const Manifesto = () => (
  <section id="manifesto" className="relative py-28 sm:py-36" data-testid="manifesto-section">
    <div className="mx-auto max-w-5xl px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8 }}
        className="mb-20"
      >
        <p className="font-mono2 text-[11px] uppercase tracking-[0.3em] text-slate-500">(06) — The Manifesto</p>
        <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-[#0a0a0a] sm:text-5xl">
          Why most traders struggle. <span className="font-accent text-grad-aurora">How we work differently.</span>
        </h2>
      </motion.div>

      <div className="space-y-0">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: 0.05 * i }}
            data-testid={`manifesto-chapter-${c.n}`}
            className="group grid gap-4 border-l-2 border-t border-l-black/10 border-black/10 py-10 pl-6 transition-colors duration-500 last:border-b hover:border-l-[#0a0a0a] sm:grid-cols-[120px_1fr_2fr] sm:gap-8 sm:pl-8"
          >
            <span className="font-display text-5xl font-extrabold text-black/10 transition-colors duration-500 group-hover:text-black sm:text-6xl">
              {c.n}
            </span>
            <h3 className="font-sub text-xl font-semibold uppercase tracking-wide text-[#0a0a0a] sm:text-2xl">
              {c.title}
            </h3>
            <p className="max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
